import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import Tenders from "./PurchaseHead/TendersAll";
import BidsTable from "./TechnicalHead/BidsTable";
import ItemCount from "../../utils/ItemCount";

const PurchaseHeadPending = () => {
  const [tenders, setTenders] = useState();
  const [vq, setVq] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "REVIEW");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);

  const [reviewCount, setReviewCount] = useState(0);
  const [vendorCount, setVendorCount] = useState(0);
  const [bidCount, setBidCount] = useState(0);

  useEffect(() => {
    const getReviewCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=REVIEW`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setReviewCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getReviewCount();

    const getVendorCount = async () => {
      try {
        const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
        setVendorCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    };
    getVendorCount();
    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBidCount();
    localStorage.removeItem('activeTab')
    localStorage.removeItem('action')
  }, []);

  const getTenders = async () => {
    setTenders();
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}&status=${activeTab}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTenders(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (activeTab !== "VQ" && activeTab !== "VENDOR" && activeTab !== "BIDS") {
      getTenders();
    }
    if (activeTab === "VENDOR") {
      const getVTenders = async () => {
        setTenders();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getVTenders();
    }
    if(activeTab === "BIDS"){
      localStorage.removeItem("tab")
      const getBidsByTender = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getBidsByTender();
    }
  }, [activeTab]);

  const getVendorTenders = async () => {
    setIsVQLoading(true)
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsVQLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (activeTab === "VQ") {
      getVendorTenders();
    }
  }, [activeTab]);

  return (
    <Box sx={{ textAlign: "center" }}>
      
          <Typography variant="h5" textAlign={"start"} fontWeight={"bold"}>
            My Pending Actions
          </Typography>
          <Box
            className="dashboard-container"
            sx={{ height: 400, width: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
                borderBottom: "1px solid #D1D1D1",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <Button
                  className={`dashboard-btns ${
                    activeTab === "REVIEW" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("REVIEW");
                    setIsLoading(true);
                    localStorage.setItem("activeTab", "REVIEW")
                }}
                >
                  Tender Review <ItemCount count={reviewCount} />
                </Button>
                <Button
                  className={`dashboard-btns ${
                    activeTab === "VQ" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("VQ");
                    setIsLoading(true);
                    localStorage.setItem("activeTab", "VQ")
                }}
                >
                  Vendor Qualification <ItemCount count={vendorCount} />
                </Button>
                <Button
                  className={`dashboard-btns ${
                    activeTab === "BIDS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("BIDS");
                    setIsLoading(true);
                    localStorage.setItem("activeTab", "BIDS")
                }}
                >
                  Bids Qualification <ItemCount count={bidCount} />
                </Button>
              </Box>
            </Box>
            {activeTab === "REVIEW" && (
              <Tenders
                tenders={tenders}
                isLoading={isLoading}
                getTenders={getTenders}
              />
            )}

            {activeTab === "VQ" ? (
              <VQTable
                vendors={vq}
                activeTab={activeTab}
                isLoading={isVQLoading}
                getVendorTenders={getVendorTenders}
              />
            ) : null}
            {activeTab === "BIDS" && (
            <BidsTable
              tenders={tenders}
              isLoading={isLoading}
              storedUser={storedUser}
            />
          )}
          </Box>
    </Box>
  );
};

export default PurchaseHeadPending;